<template>
  <div class="grilla-simplificada-solicitud">
    <div class="grilla-header">
      <div class="custom-label">Cantidades a cotizar</div>
      <el-button
        link
        type="primary"
        size="default"
        :icon="IconAdd"
        @click="emit('add-cantidad')"
      >
        Agregar cantidad
      </el-button>
    </div>

    <el-table
      border
      size="small"
      empty-text="Sin cantidades"
      :data="cantidades"
      :class="{ 'input-error': hasError }"
    >
      <el-table-column
        label="#"
        width="40"
        align="center"
      >
        <template #default="{ $index }">{{ $index + 1 }}</template>
      </el-table-column>

      <el-table-column
        label="Cantidad"
        width="250"
        align="right"
      >
        <template #default="{ row, $index }">
          <el-input-number
            :model-value="row.Cantidad"
            :controls="false"
            :precision="precision"
            :min="0"
            size="small"
            class="grilla-input"
            placeholder="Cantidad"
            @update:model-value="onUpdate($index, 'Cantidad', $event)"
          />
        </template>
      </el-table-column>

      <el-table-column
        width="150"
        align="right"
      >
        <template #header>
          <el-tooltip
            content="Precio objetivo del cliente"
            placement="top"
          >
            <span>Precio Referencia</span>
          </el-tooltip>
        </template>
        <template #default="{ row, $index }">
          <el-input-number
            :model-value="row.PrecioReferencia"
            :controls="false"
            :precision="2"
            :min="0"
            size="small"
            class="grilla-input"
            placeholder="Opcional"
            @change="onUpdate($index, 'PrecioReferencia', $event)"
          />
        </template>
      </el-table-column>

      <el-table-column
        width="50"
        align="center"
      >
        <template #default="{ $index }">
          <el-tooltip
            content="Quitar"
            placement="top"
          >
            <el-button
              link
              type="danger"
              :icon="IconDelete"
              @click="emit('remove-cantidad', $index)"
            />
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script setup>
import IconAdd from '~icons/mdi/add';
import IconDelete from '~icons/mdi/delete';

defineProps({
  cantidades: { type: Array, required: true, default: () => [] },
  hasError: { type: Boolean, default: false },
  precision: { type: Number, default: 0 },
});

const emit = defineEmits(['add-cantidad', 'remove-cantidad', 'update-cantidad']);

const onUpdate = (index, field, value) => {
  emit('update-cantidad', { index, field, value });
};
</script>

<style scoped>
.grilla-simplificada-solicitud {
  width: 100%;
  max-width: 480px;
}

.grilla-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
}

.custom-label {
  font-weight: 700;
  color: #111;
}

.grilla-input {
  width: 100%;
}

.input-error :deep(.el-table__inner-wrapper)::before {
  background-color: var(--el-color-danger);
}
</style>
